import type { BackendRouteDefinition } from '../types';

export const getFirmInfoForHandleRoute = {
  transport: 'api',
  method: 'GET',
  path: '/public/firms/by-handle/:firmHandle',
  params: ({ firmHandle }: { firmHandle: string }) => ({
    firmHandle,
  }),
} as const satisfies BackendRouteDefinition;
